import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { GroupParticipant } from 'src/app/calibration/_interfaces/group-participant.interface';
import {
    ParticipantOverview,
    ParticipantRatingsDict,
    UserOverviewPositions
} from 'src/app/calibration/_interfaces/participant-overview.interface';
import { CalibrationService } from 'src/app/calibration/calibration.service';
import { CalibrationUserCommentModal } from 'src/app/calibration/components/user-comment/user-comment.modal';
import { BaseClass } from 'src/app/shared/classes/base';
import { UserRoleEnum } from 'src/app/shared/enums/UserRoleEnum';
import { JobFollowUpService } from 'src/app/shared/modals/job-follow-up/job-follow-up.service';
import { JobParams } from 'src/app/shared/modals/job-follow-up/models/jobs';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { UtilService } from 'src/app/shared/services/util.service';
import {
    AiGeneralSummaryModalComponent
} from '../../../shared/modals/ai-general-summary-modal/ai-general-summary-modal.component';
import { AuthService } from '../../../shared/services/auth.service';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-calibration-user-overview',
    templateUrl: './user-overview.modal.html',
    styleUrls: ['./user-overview.modal.scss']
})
export class CalibrationUserOverviewModal extends BaseClass implements OnInit {
    public hideHireDate: boolean;
    public aiReviewEnabled: boolean;
    public hideOverallEvaluationCard: boolean;
    public hasAiReviewRole: boolean = false;

    public participant: Partial<ParticipantOverview>;
    public userOverviews: Array<Partial<ParticipantOverview>>;
    public userInfo: GroupParticipant;
    public cycleYear: number;
    public availableYears: Array<number> = [];
    public positions: UserOverviewPositions = { hasPrevious: false, hasNext: false };

    public yearColors: Array<string> = [
        '#001E62',
        '#0A1E8C',
        '#195AB4'
    ]

    public managerEvaluationView: boolean = false;
    public meetingInProgress: boolean = true;
    public cycleId: number;
    public selectedLanguage: string;
    public hasAiReviewAttribute: boolean = false;

    private readonly _groupId: number;
    private readonly _userId: string;
    private readonly _participantId: number;
    private readonly _calibrationProcessId: number;
    public isManager: boolean;
    public canExportFullReport: boolean;
    public canViewComments: boolean;
    public canExportReport: boolean;
    public questionGroupsCalibrationData: any[] = [];
    public lastQuestionGroupCalibration: any;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _navParams: NavParams,
        private _calibrationService: CalibrationService,
        private _utilService: UtilService,
        private _router: Router,
        private _jobFollowUpService: JobFollowUpService,
        private _authService: AuthService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
        this.userInfo = this._navParams.get('userInfo');
        this.cycleId = this._navParams.get('cycleId');
        this._groupId = this._navParams.get('groupId');
        this._userId = this._navParams.get('userId');
        this._calibrationProcessId = this._navParams.get('calibrationProcessId');
        this._participantId = this._navParams.get('cycleParticipantId');
        this.managerEvaluationView = this._navParams.get('managerEvaluationView');
        this.meetingInProgress = this._navParams.get('meetingInProgress');

    }

    ngOnInit() {
        this.hideHireDate = this._configService.settings.features.hideHireDate;
        this.aiReviewEnabled = this._configService.settings.features.aiReview;
        this.hideOverallEvaluationCard = this._configService.settings.features.hideOverallEvaluationCard;

        this.selectedLanguage = this._translationService.getSelectedLanguage();
        console.log('this.positions', this.positions);
        this.setSubscriptions();

        this._loadCalibrationSummary(
            this._participantId, this.cycleId, this.selectedLanguage
        );

        this.assignUserPermissions();
        if (this.aiReviewEnabled) {
            this._hasAiReviewAccess();
        }

    }
    private setSubscriptions() {
        this._authService.getIsManagerUser().subscribe((resp) => {
            this.isManager = resp.manager;
            this.assignUserPermissions();
        });
    }

    private assignUserPermissions() {
        const isUserAdmin = this._authService.hasRoleImpersonated(UserRoleEnum.Administrator);
        const isBpUser = this._authService.hasRoleImpersonated(UserRoleEnum.BusinessPartner);
        const isViewer = this._authService.hasRoleImpersonated(UserRoleEnum.CalibrationVisibility);
        const hasAIReview = this._authService.hasRoleImpersonated(UserRoleEnum.AIReview);//somente será exibido se o usuário possuir o papel "AI – Review"

        this.hasAiReviewRole = hasAIReview;

        //Relatório Completo: Será exibido apenas se o usuário tiver um dos papéis "BP", "Admin", "Manager".
        this.canExportFullReport = this.isManager || isUserAdmin || isBpUser;;
        //Comentários: Será exibido apenas se o usuário tiver um dos papéis "BP", "Admin", "Manager".
        this.canViewComments = this.isManager || isUserAdmin || isBpUser;
        //Exportar:Será exibido apenas se o usuário tiver um dos papéis "BP", "Admin", "Manager".
        this.canExportReport = this.isManager || isUserAdmin || isBpUser;



    }

    public async dismiss(nextUser?: string): Promise<void> {
        await this._modalController.dismiss(nextUser);
    }

    public getTotalEvaluators(ratings: ParticipantRatingsDict): number {
        const keys = Object.keys(ratings);
        let total = 0;

        keys.forEach(key => {
            total = total + ratings[key];
        });

        return total;
    }

    public getRatingTotals(rating: string): number {
        return this.participant.ratings.freeEvaluationRatings[rating] +
            this.participant.ratings.directReportRatings[rating] +
            this.participant.ratings.threeSixtyRatings[rating];
    }

    public getYearColor() {
        return this.yearColors[this.cycleYear - this.participant.year];
    }

    public getPreviousYearStat(year: number, stat: string): string {
        if (!this.participant || !this.participant.previousEvaluations || !this.participant.previousRankYearStats)
            return '--';

        if (stat === 'evaluation') {
            const valueForTheYear = this.participant.previousEvaluations.find(ev => ev.year === year);
            return valueForTheYear ? (isNaN(parseFloat(valueForTheYear.value)) ? valueForTheYear.value : parseFloat(valueForTheYear.value).toFixed(2)) : '--';
        } else {
            const valueForTheYear = this.participant.previousRankYearStats.find(ev => ev.year === year);
            return valueForTheYear ? (isNaN(parseFloat(valueForTheYear.value)) ? valueForTheYear.value : parseFloat(valueForTheYear.value).toFixed(2)) : '--';
        }
    }

    public async exportReport(): Promise<void> {
        this._calibrationService.exportPresentation({
            cycleId: this.cycleId,
            groupId: this._groupId,
            calibrationProcessId: this._calibrationProcessId,
            cycleParticipantId: this._participantId
        }).subscribe(response => {
            const jobId = response.data;
            this.notify(this._translationService.getTranslation('Report.SendByEmail'), 'success');
            const jobName = `${this._translationService.getTranslation('calibration.presentation')} - ${this.participant.user.name}`;
            const job = new JobParams({
                jobId: jobId,
                filters: { cycleParticipantId: this._participantId },
                cycleId: this.cycleId,
                jobName: jobName,
                group: this._groupId,
                processId: this._calibrationProcessId,
                type: 'exportPresentation',
            });
            this._jobFollowUpService.startPollingForJobProgress(() => this._calibrationService.getJobStatus(job.jobId), job);
        }, (error) => {
            this.notifyError(error);
        });
    }

    public viewFullReport(): void {
        localStorage.setItem(
            'FinalReport_ReturnPath',
            this.managerEvaluationView ?
                'manager-evaluation/' + this.cycleId :
                'calibration/' + this.cycleId + '/' + this._calibrationProcessId + '/' + this._groupId
        );

        this.dismiss();
        this._router.navigate([
            'final-report/' + this.cycleId + '/' + this._userId
        ]);
    }

    private _loadCalibrationSummary(participantId: number, cycleId: number, selectedLanguage: string) {
        this._calibrationService.getCalibrationUserSummary(participantId, cycleId, selectedLanguage)
            .subscribe((response) => {
                this.userOverviews = response.data;
                this.userOverviews.forEach(user => {
                    if (user.questionsGroupsCalibrationData) {
                        user.questionsGroupsCalibrationData.forEach(group => {
                            group.questions = this._utilService.groupQuestions(
                                group.questions
                            );
                        });
                    }

                    if (user.threeSixtyEvaluationCalibrationData) {
                        user.threeSixtyEvaluationCalibrationData.forEach(group => {
                            group.questions = this._utilService.groupQuestions(
                                group.questions
                            );
                        });
                    }
                });
                this.availableYears = this.userOverviews.map(user => user.year);
                this.participant = this.userOverviews[0];

                this.setQuestionGroupsCalibrationData(this.participant);

                this.cycleYear = this.participant.year;
            }, (error) => {
                this.notifyError(error);
            });
    }

    public setQuestionGroupsCalibrationData(participant) {

        this.questionGroupsCalibrationData = participant.questionsGroupsCalibrationData || [];

        if (this.questionGroupsCalibrationData.length > 2) {
            this.lastQuestionGroupCalibration = this.questionGroupsCalibrationData.pop();
        }
    }


    public selectYear(year: number): void {
        this.participant = this.userOverviews.find(user => user.year === year);
        this.setQuestionGroupsCalibrationData(this.participant);
    }

    public goToManagerEvaluation(): void {
        if (!this.managerEvaluationView) {
            localStorage.setItem(
                'UserOverview_ReturnPath',
                'calibration/' + this.cycleId + '/' + this._calibrationProcessId + '/' + this._groupId
            );
        }

        this._router.navigate([
            'manager-evaluation/' + this.cycleId + '/' + this.participant.user.userId + '/calibration'
        ]);
        this.dismiss();
    }

    public async viewUserComments(userInfo: GroupParticipant): Promise<void> {
        const modal = await this._modalController.create({
            component: CalibrationUserCommentModal,
            componentProps: {
                'user': userInfo,
                'groupId': this._groupId,
                'cycleId': this.cycleId
            }
        });

        await modal.present();
    }

    public getLocalDate(date: string) {
        if (date && date.length > 0) {
            let dateFormatted: Date = new Date(date);
            dateFormatted.setHours(dateFormatted.getHours() + 3);
            return dateFormatted;
        }
        return date;
    }

    public async openAiGeneralSummaryModal() {
        if (!this.participant) {
            this.participant = this.userOverviews[0];
            this.setQuestionGroupsCalibrationData(this.participant);
        }
        const modal = await this._modalController.create({
            component: AiGeneralSummaryModalComponent,
            componentProps: {
                participant: this.participant,
                cycleParticipantId: this.participant.cycleParticipantId,
                cycleId: this.cycleId,
                groupId: this._groupId,
                calibrationProcessId: this._calibrationProcessId,
            },
            cssClass: 'ai-management-evaluation-detailed round'
        });

        modal.onDidDismiss().then((response) => {
            if (response.data.closeParent) {
                this._modalController.dismiss(null, null, "userOverviewModal")
            }
        });

        await modal.present();
    }

    private _hasAiReviewAccess() {
        this._calibrationService.getHasReviewAccess(
            this._authService.getLoggedUserId()
        ).subscribe((response) => {
            this.hasAiReviewAttribute = response.data;
        }, (error) => this.notifyError(error));
    }
}
